import { api } from '@/lib/api'

import { OnboardingStepDetails } from '../types'

export function getOnboardingStepDetails(name: string) {
  return api.get<OnboardingStepDetails>(`/v1/onboarding/step/${name}`)
}
